import { Button, Card, Input } from "antd";
import styled from "styled-components";

export const PatientCard = styled(Card)`
  border-color: transparent;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
  /* width: 33%; */
  border-radius: 15px;
  height: 225px;
  
  .ant-card-body {
    padding: 21px;
    padding-top: 0px;
  }
  /* color:#FFFFFF; */
  .ant-card-head {
    border-bottom: none;
  }
  .ant-card-head-title {
    padding: 8px 0px;
    color: ${(props) => props.theme.colors.primary};
  }
  .ant-card-extra {
    padding: 8px 0px;
  }
`;

export const DetailSpan = styled.span`
  margin-left: 10px;
  text-transform: capitalize;
  font-size: 14px;
  .emailEllipsis {
    display: inline-block;
    max-width: 80% !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  @media (max-width: 281px) {
    .emailEllipsis {
      max-width: 75% !important;
    }
  }
  @media (min-width: 1199px) and (max-width: 1400px) {
    .emailEllipsis {
    max-width: 75% !important;
    }
  }
  a {
    color: #883da9;
  }
`;

export const InputBox = styled(Input)`
  input {
    font-size: 14px;
  }
`;

export const XButton = styled(Button)`
  font-size: 14px;
  border-radius: 7px !important;
`;
